<template>
  <PageTemplate>
    <template slot="title">{{ this.$t("order") }}</template>
    <template slot="content">
      <div style="margin: 8px;">
        <v-data-table
          :headers="headers"
          :items="orderData"
          no-data-text="Loading"
          hide-default-footer
          class="elevation-7"
        >
          <template #item.quantity="{ item }"
            >{{ item.quantity }} {{ item.unit }}</template
          >
          <template v-slot:item.priceWithoutTax="{ item }">
            {{ fixed(item.priceWithoutTax) }}
            {{
              $store.state.userProfile.currentWholesaler.settings.currencyCode
            }}
          </template>
        </v-data-table>
        <v-btn
          block
          style="margin-top: 8px;"
          elevation="5"
          color="accent"
          @click="repeatOrder()"
          >{{ this.$t("repeat_order") }}</v-btn
        >
      </div>
    </template>
  </PageTemplate>
</template>

<script>
import Constants from "@/Constants";
import { mapActions } from "vuex";
import PageTemplate from "../../templates/PageTemplate";
export default {
  name: "OrderPage",
  components: { PageTemplate },
  data() {
    return {
      proWebBasket: null,
      order: {},
      quantity2: "",
      index: "",
      orderId: "",
      orderData: [],
      generatedProduct: {},
      headers: [
        {
          text: this.$t("product"),
          value: "productName",
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("quantity"),
          value: "quantity",
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("price"),
          value: "priceWithoutTax",
          align: "left",
          sortable: false,
        },
      ],
    };
  },
  created() {
    this.order = this.$route.params.order;
    this.orderId = this.$route.params.order.id;
    this.$http
      .get(Constants.apiMethod.order.concat("=").concat(this.orderId))
      .then((response) => {
        this.orderData = response.data;
        console.log(response.data);
        // for (var i = 0; i < this.orderData.length; i++) {
        //   this.orderData[i].priceWithoutTax =
        //     this.orderData[i].priceWithoutTax +
        //     " " +
        //     this.$store.state.userProfile.currentWholesaler.settings
        //       .currencyCode;
        // }
        this.hideProgressBar();
      });
  },
  methods: {
    fixed(value) {
      return parseFloat(value).toFixed(2);
    },
    repeatOrder() {
      console.log(this.orderData);
      this.orderData.forEach((element) => {
        this.generateBasketItemAction(element);
      });
    },
    generateBasketItemAction(element) {
      this.$http
        .get(
          Constants.apiMethod.generateBasketItem
            .concat("productId=")
            .concat(element.productId)
            .concat("&quantity=")
            .concat(element.quantity)
            .concat("&unit=")
            .concat(element.unit)
        )
        .then((response) => {
          // console.log(response.data)
          this.generatedProduct = response.data;
          this.proWebBasket = JSON.parse(localStorage.getItem("proWebBasket"));
          if (
            this.proWebBasket.find(
              (s) => s.product.code === this.generatedProduct.product.code
            )
          ) {
            this.index = this.proWebBasket.findIndex(
              (s) => s.product.code === this.generatedProduct.product.code
            );
            this.proWebBasket[this.index] = this.generatedProduct;
            localStorage.setItem(
              "proWebBasket",
              JSON.stringify(this.proWebBasket)
            );
          } else {
            this.proWebBasket.push(this.generatedProduct);
            localStorage.setItem(
              "proWebBasket",
              JSON.stringify(this.proWebBasket)
            );
            this.text = this.$t("add_basket_item_success_message");
            this.snackbar = true;
          }
          this.$store.state.badgeCounter = this.proWebBasket.length;
        });
    },
    ...mapActions(["showProgressBar", "hideProgressBar"]),
  },
};
</script>

<style scoped></style>
